<template>
  <div class="col-12 p-0" v-if="post">
    <div class="col-12 p-0 mb-2" style="border-bottom: 1px solid #dedede;">
      <forum-post :post="post" :type="'post'" :route-to-post-onclick="false" @post-deleted="$router.back()" @edit-post="onEditPost"></forum-post>
    </div>

    <!-- Replies-->
    <div class="col-12 p-0 pb-2">
      <div class="pb-5">
        <div class="col-12 pr-0" v-for="reply in replies" :key="reply._id">
          <forum-post :post="reply" :type="'reply'" @post-deleted="onReplyDeleteOrEdit" @edit-post="onEditReply"></forum-post>
        </div>

        <infinite-loading spinner="waveDots" @infinite="getReplies" forceUseInfiniteWrapper="window" :identifier="post._id">
          <span slot="no-more">{{ $t('message.No more comments') }}</span>
          <span slot="no-results">
            <p><i style="color: gray; padding-right: 0.5em;" class="fa fa-file-invoice"></i> {{ $t('message.No comments yet') }} </p>
          </span>
        </infinite-loading>
      </div>

    </div>

    <n-button icon type="primary" round size="lg" social style="top: auto;inset-inline-end: 10px;bottom: 0rem;inset-inline-start: auto;position: fixed;z-index: 999;" float @click.native="showWriteReplyModal">
      <i class="fas fa-comment"></i>
    </n-button>

    <modal :show.sync="PREVIEW_FILE" headerclasses="justify-content-center" v-if="fileToPreview">
      <h6 slot="header" class="title title-up">File Preview</h6>

      <card>
        <div class="row justify-content-center">
          <!-- Thumbnail -->
          <div class="col-12 pr-0">
            <dynamic-image v-if="fileToPreview.type.indexOf('image') > -1" :file-id="fileToPreview.fileId">
            </dynamic-image>
            <dynamic-video v-if="fileToPreview.type.includes('video/')" :file-id="fileToPreview.fileId" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; width: 100%" :options="{ controls: true }" />
            <!-- <i class="fa fa-file-pdf-o" style="font-size: 2em" v-if="attachment.type.indexOf('pdf') > -1"></i> -->
          </div>
        </div>
      </card>
    </modal>

    <modal :show.sync="SHOW_WRITE_REPLY_MODAL" headerClasses="d-none" class="write-post-modal" footerClasses="d-none" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250" @close="closeWriteReplyModal">

      <create-forum-post v-if="SHOW_WRITE_REPLY_MODAL" :type="'Reply'" :replyTo="post" @forumPostCreated="onPostReply" @cancel="closeWriteReplyModal"></create-forum-post>

    </modal>

    <!-- edit modal-->
    <modal :show.sync="SHOW_EDIT_POST_MODAL" headerClasses="d-none" class="write-post-modal" footerClasses="justify-content-center" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250" @close="SHOW_EDIT_POST_MODAL = false; getForumPost($route.params.postId)">
      <create-forum-post v-if="SHOW_EDIT_POST_MODAL" :type="'Post'" :updatePost="updatePost" @forumPostCreated="SHOW_EDIT_POST_MODAL = false; getForumPost($route.params.postId)" @cancel="SHOW_EDIT_POST_MODAL = false; getForumPost($route.params.postId)"></create-forum-post>
      <template slot="footer">
      </template>
    </modal>

    <!-- edit reply modal-->
    <modal :show.sync="SHOW_EDIT_REPLY_MODAL" headerClasses="d-none" class="write-post-modal" footerClasses="justify-content-center" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250" @close="SHOW_EDIT_REPLY_MODAL = false; onReplyDeleteOrEdit()">
      <create-forum-post v-if="SHOW_EDIT_REPLY_MODAL" :type="'Reply'" :updatePost="updatePost" @forumPostCreated="SHOW_EDIT_REPLY_MODAL = false; onReplyDeleteOrEdit()" @cancel="SHOW_EDIT_REPLY_MODAL = false; onReplyDeleteOrEdit()"></create-forum-post>
      <template slot="footer">
      </template>
    </modal>
  </div>
</template>

<script>
import ForumPost from "../components/forum/ForumPost.vue";
import CreateForumPost from "../components/forum/CreateForumPost.vue";

export default {
  name: "view-forum-post",
  data() {
    return {
      post: null,
      PREVIEW_FILE: false,
      fileToPreview: null,
      replies: [],
      repliesPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 10,
      },
      SHOW_WRITE_REPLY_MODAL: false,
      reply: "",
      updatePost: {},
      SHOW_EDIT_POST_MODAL: false,
      SHOW_EDIT_REPLY_MODAL: false,
    };
  },
  async beforeRouteUpdate(to, from) {
    // react to route changes...
    this.getForumPost(to.params.postId);
  },
  components: {
    ForumPost,
    CreateForumPost,
  },
  async mounted() {
    this.$root.onBackButton = () => {
      if (this.$store.state.postRouteStack.length - 1) {
        this.$store.state.postRouteStack.pop();
        delete this.$store.state.forumPostCache[this.post._id];
        let prevPostId =
          this.$store.state.postRouteStack[
          this.$store.state.postRouteStack.length - 1
          ];
        this.getForumPost(prevPostId);
      } else {
        this.$router.back();
      }
    };
    await this.getForumPost(this.$route.params.postId);
  },
  computed: {
    liked() {
      return this.post.likes.includes(this.user._id);
    },
  },
  methods: {
    onReplyDeleteOrEdit() {
      this.resetReplies();
      this.getReplies();
    },
    onEditPost(post) {
      this.updatePost = post;
      this.SHOW_EDIT_POST_MODAL = true;
    },
    onEditReply(post) {
      this.updatePost = post;
      this.SHOW_EDIT_REPLY_MODAL = true;
    },
    async getForumPost(id) {
      let loader = this.$loading.show();
      try {
        let forumPostCache = this.$store.state.forumPostCache;
        this.resetReplies();
        if (forumPostCache && forumPostCache[id]) {
          this.post = forumPostCache[id];
        } else {
          this.post = await this.$store.dispatch("getForumPostById", id);
        }
      } catch (error) {
        console.error(error);
      }
      loader.hide();
    },
    async likeOrDislikePost() {
      try {
        let response = await this.$store.dispatch("toggleLike", {
          userId: this.user._id,
          postId: this.post._id,
        });
        this.post.likes = response.likes;
      } catch (error) {
        console.log(error);
      }
    },
    resetReplies() {
      this.replies = [];
      this.repliesPagination = {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 10,
      };
    },
    async getReplies($state) {
      try {
        let response = await this.$store.dispatch("getReplies", {
          pageNumber: this.repliesPagination.pageNumber,
          pageSize: this.repliesPagination.pageSize,
          postId: this.post._id,
        });

        if (response.data && response.data.length) {
          this.replies.push(...response.data);
          this.repliesPagination.totalPages = response.totalPages;
          this.repliesPagination.pageNumber += 1;
          if ($state) {
            $state.loaded();
          }
        } else {
          if ($state) {
            $state.complete();
          }
        }
      } catch (error) {
        console.log(error);
        if ($state) {
          $state.complete();
        }
      }
    },
    showWriteReplyModal() {
      this.SHOW_WRITE_REPLY_MODAL = true;
    },
    closeWriteReplyModal() {
      this.SHOW_WRITE_REPLY_MODAL = false;
    },
    onPostReply() {
      this.SHOW_WRITE_REPLY_MODAL = false;
      this.resetReplies();
      this.getReplies();
      this.fetchPost()
    },
    async fetchPost() {
      this.post = await this.$store.dispatch("getForumPostById", this.post._id);
      let forumPostCache = structuredClone(this.$store.state.forumPostCache);
      forumPostCache[this.post._id] = this.post;
      this.$store.commit("setState", {
        stateName: "forumPostCache",
        stateValue: forumPostCache,
      });
      this.$store.state.forumPosts = null
    },
    viewFile(file) {
      this.fileToPreview = file;
      this.PREVIEW_FILE = true;
    },
  },
};
</script>

<style scoped>
/deep/.write-post-modal .modal-dialog {
  width: 100%;
  margin: 0;
  overflow: hidden;
  max-width: none;
}

/deep/.write-post-modal .modal-body {
  height: 100vh;
  padding-top: 16px;
  padding-right: 16px;
  padding-left: 16px;
}

/deep/.write-post-modal-content {
  height: 100vh;
}

/deep/.write-post-modal-content .modal-header button {
  position: static;
}
</style>
